import { createContext, useContext, useEffect, useState, ReactNode } from 'react';

export type ThemeMode = 'light' | 'dark';

type ThemeCtx = { theme: ThemeMode; setTheme: (t: ThemeMode) => void; toggleTheme: () => void };

const ThemeContext = createContext<ThemeCtx>({ theme: 'light', setTheme: () => {}, toggleTheme: () => {} });

export function ThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setThemeState] = useState<ThemeMode>(() => {
    try { return (localStorage.getItem('poyais_theme') as ThemeMode) || 'light'; } catch { return 'light'; }
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try { localStorage.setItem('poyais_theme', theme); } catch {}
  }, [theme]);

  const setTheme = (t: ThemeMode) => setThemeState(t);
  const toggleTheme = () => setThemeState(v => (v === 'light' ? 'dark' : 'light'));

  return <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  return useContext(ThemeContext);
}

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  return (
    <div style={{ display: 'flex', background: 'var(--py-track-bg)', borderRadius: 8, padding: 2, gap: 2, flexShrink: 0 }}>
      {([
        { mode: 'light' as ThemeMode, icon: '☀️' },
        { mode: 'dark' as ThemeMode, icon: '🌙' },
      ]).map(({ mode, icon }) => (
        <button
          key={mode}
          onClick={() => setTheme(mode)}
          title={mode === 'light' ? 'Açık Tema' : 'Koyu Tema'}
          style={{
            width: 26,
            height: 26,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 6,
            border: 'none',
            background: theme === mode ? 'var(--py-surface)' : 'transparent',
            boxShadow: theme === mode ? '0 1px 2px rgba(20,22,43,.1)' : 'none',
            fontSize: 12,
            cursor: 'pointer',
            lineHeight: 1,
          }}
        >
          {icon}
        </button>
      ))}
    </div>
  );
}
